import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@material-ui/core';
import { createDefaultTitle, Title } from '../../domain/domain';
import React, { useEffect, useState } from 'react';

type Props = {
    open: boolean,
    onOK: (title: Title) => void,
    onCancel: () => void
}

const AddTitleDialog: React.FC<Props> = ({ open, onOK, onCancel }) => {

    const [title, setTitle] = useState<Title>(createDefaultTitle());

    // Reset form when dialog opens
    useEffect(() => {
        if (open) {
            setTitle(createDefaultTitle());
        }
    }, [open]);

    // Disable save button if either field is blank or only contains whitespace
    const isSaveDisabled = !title.titleName.trim() || !title.titleNumber.trim();

    const handleCancel = () => {
        setTitle(createDefaultTitle());
        onCancel();
    };

    const handleSave = () => {
        onOK(title);
        setTitle(createDefaultTitle());
    };

    return (
        <Dialog
            open={open}
            title="Add New Title"
            onClose={handleCancel}
            maxWidth='sm'
            fullWidth={true}
        >
            <DialogTitle>Add New Title</DialogTitle>
            <DialogContent>
                <Grid item style={{ width: '100%' }}>
                    <Grid container direction='column'>
                        <Grid item>
                            <Typography style={{ width: '100%' }}>Title Number</Typography>
                        </Grid>
                        <Grid item style={{ width: '100%' }}>
                            <TextField
                                variant='outlined'
                                value={title.titleNumber}
                                onChange={(event) => {
                                    setTitle({ ...title, titleNumber: (event.target.value) + "" })
                                }}
                                size='small'
                                fullWidth={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <br></br>
                <Grid container direction='column' className="flex-gap-2" alignItems='flex-start'>
                    <Grid item style={{ width: '100%' }}>
                        <Grid container direction='column'>
                            <Grid item>
                                <Typography style={{ width: '100%' }}>Title Name</Typography>
                            </Grid>
                            <Grid item style={{ width: '100%' }}>
                                <TextField
                                    variant='outlined'
                                    value={title.titleName}
                                    onChange={(event) => {
                                        setTitle({ ...title, titleName: event.target.value })
                                    }}
                                    size='small'
                                    fullWidth={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='text' color='secondary' onClick={handleCancel}>Cancel</Button>
                <Button
                    size='small'
                    variant='contained'
                    color='primary'
                    onClick={handleSave}
                    disabled={isSaveDisabled}
                >
                    Add Title
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddTitleDialog;